import { admin2 } from '@/api/instance'

const baseUrl = (shopId) => `/${shopId}/mTagGroup`

/**
 * 建立標籤群組 admin.mTagGroup.create
 * @param {Object} params - 建立參數
 * @param {string} params.shopId - 商店 ID
 * @param {string} params.name - 群組名稱
 * @param {Array<{mTagId: string, order: number}>} [params.mTags] - 初始標籤與排序
 * @returns {Promise<[Object, null]|[null, string]>} [data, errMsg]
 */
export const CreateMTagGroup = async ({ shopId, name, mTags }) => {
  return await admin2({
    method: 'post',
    url: `${baseUrl(shopId)}`,
    data: {
      name,
      mTags,
    },
  })
}

/**
 * 取得標籤群組列表 admin.mTagGroup.find
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店 ID
 * @param {string} [params.name] - 群組名稱（模糊搜尋）
 * @param {number} [params.start=0] - 查詢起始
 * @param {number} [params.limit=20] - 查詢筆數
 * @returns {Promise<[Array, null]|[null, string]>} [data, errMsg]
 */
export const GetMTagGroups = async ({ shopId, name, start, limit }) => {
  return await admin2({
    method: 'get',
    url: `${baseUrl(shopId)}`,
    params: {
      name,
      start,
      limit,
    },
  })
}

/**
 * 取得標籤群組總數 admin.mTagGroup.count
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店 ID
 * @param {string} [params.name] - 群組名稱（模糊搜尋）
 * @returns {Promise<[number, null]|[null, string]>} [data, errMsg]
 */
export const GetMTagGroupCount = async ({ shopId, name }) => {
  return await admin2({
    method: 'get',
    url: `${baseUrl(shopId)}/count`,
    params: {
      name,
    },
  })
}

/**
 * 查詢特定標籤群組 admin.mTagGroup.findOne
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店 ID
 * @param {string} params.id - 群組 ID
 * @returns {Promise<[Object, null]|[null, string]>} [data, errMsg]，data 包含 MTags 與排序資訊
 * @example
 * // 回傳格式
 * {
 *   id: 'xxx',
 *   name: '群組名稱',
 *   MTags: [
 *     { id: 'tagId', name: '標籤名', memberCount: 5, MTagGroup_MTag: { order: 0 } },
 *   ]
 * }
 */
export const FindMTagGroup = async ({ shopId, id }) => {
  return await admin2({
    method: 'get',
    url: `${baseUrl(shopId)}/${id}`,
  })
}

/**
 * 更新標籤群組 admin.mTagGroup.update
 * @param {Object} params - 更新參數
 * @param {string} params.shopId - 商店 ID
 * @param {string} params.id - 群組 ID
 * @param {string} [params.name] - 群組名稱
 * @param {Array<{mTagId: string, order: number}>} [params.mTags] - 全量標籤與排序（替換現有所有標籤）
 * @returns {Promise<[Object, null]|[null, string]>} [data, errMsg]（data 不含 MTags，需接著呼叫 FindMTagGroup）
 */
export const UpdateMTagGroup = async ({ shopId, id, name, mTags }) => {
  return await admin2({
    method: 'put',
    url: `${baseUrl(shopId)}/${id}`,
    data: {
      name,
      mTags,
    },
  })
}

/**
 * 刪除標籤群組 admin.mTagGroup.delete
 * @param {Object} params - 刪除參數
 * @param {string} params.shopId - 商店 ID
 * @param {string} params.id - 群組 ID
 * @returns {Promise<[Object, null]|[null, string]>} [data, errMsg]（標籤不受影響）
 */
export const DeleteMTagGroup = async ({ shopId, id }) => {
  return await admin2({
    method: 'delete',
    url: `${baseUrl(shopId)}/${id}`,
  })
}
